/**
 * Overflow tooltip
 *
 * This module provides a way to detect if an element's content is overflowing and
 * if so, sets a tooltip with the content of the element.
 *
 */

custom.overflowTooltip = (() => {
  // Function to check for overflow and set tooltip
  function checkOverflowAndSetTooltip(els) {
    for (const el of els) {
      if (el.offsetWidth < el.scrollWidth) {
        // Content is overflowing, add tooltip
        el.setAttribute('title', el.textContent);
      } else {
        // Content fits, remove tooltip (if previously set)
        el.removeAttribute('title');
      }
    }
  }

  const init = (className) => {
    // Find all card titles
    const els = document.getElementsByClassName(className);

    if (els.length) {
      // Initial check on page load
      checkOverflowAndSetTooltip(els);
      // Re-check if the element's size or content changes (e.g., on window resize)
      window.addEventListener('resize', () => {
        custom.utils.debounce(checkOverflowAndSetTooltip(els), 100);
      });
    }
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/overflow-tooltip.js